
<template>
  <div class="header">
  <div class="headerBarTopper"></div>
  <div class="headerBar">
    <div id="logo">
      <a href="https://gonicus.de">
        <img alt="GONICUS logo" src="../assets/gonicus-logo.svg" width="250"/>
      </a>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
.header{
  display:flex;
  flex-direction: column;
  align-content: center;
  margin:auto;
  width: 100%;
  height: 7rem;
}
.headerBarTopper{
  display:inline-flex;
  background-color:#1e398f;
  width:100%;
  height:2rem;
  align-content: center;
}

.headerBar {
  display:flex;
  height: 5rem;
/**  background-color: #1e398f;*/
  background: white;
  /**position: relative;*/
/**  display: block;
  margin: center;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  object-fit: scale-down;
  clip-path: inset(3rem 0rem 3rem 0rem);
  margin-top: -3rem;*/
}
#logo {
  display:inline-flex;
  margin:left;
  transform: translateY(-60%); 
/*  width: 15rem;
  clip-path: inset(3rem 2rem 3rem 2rem);
  /**  width: 10%;
  top: -25%;*/
}
img {
/**  object-fit: cover;*/
}
</style>
